//      
                                 
import axios from "axios";
import Configuration from "../Configuration";
import {getTrafficOrigin, shouldTrackOrigin} from "../helper/trafficOrigin";
import Events from "../helper/tracker/Events";

                                   
                   
 

export default class StatisticApi {
	api       ;

	constructor(configId        , {
		language = navigator.language || "en-GB",
	}                      = {}) {
		const headers = {
			"X-ModuleType": "SELEKT",
			"Accept-Language": language + ", *;q0.5",
			"X-Origin": getTrafficOrigin() || "unknown",
			"X-ConfigId": configId,
		};
		this.api = axios.create({
			baseURL: Configuration.value("apiBaseUrl"),
			headers
		});
	}

	trackModuleLoad = ()       => {
		if (shouldTrackOrigin()) {
			this.trackEvent(Events.ACTIONS.SHOP.LOADED);
		}
	};

	trackProductShared = (productNo        )       => {
		this.trackEvent(Events.ACTIONS.PRODUCT.PRODUCT_SHARED, productNo);
	};

	trackAddedToWatchlist = (productNo        )       => {
		this.trackEvent(Events.ACTIONS.BOOKMARKS.ADD_PRODUCT, productNo);
	};

	trackProductQuestion = (productNo        )       => {
		this.trackEvent(Events.ACTIONS.PRODUCT.PRODUCT_QUESTION, productNo);
	};

	trackProductAddedToCart = (productNo        )       => {
		this.trackEvent(Events.ACTIONS.CART.ADD_PRODUCT, productNo);
	};

	trackEvent = (eventType         = "", productNo         = "")       => {
		this.api.post("/v2/loading/completed",
			{},
			{
				headers: {
					"X-Event-Type": eventType,
					"X-Product-No": productNo.trim()
				}
			}).catch(() => {
		});
	};
}
